<div [formGroup]="formGroup" [ngStyle]="border"
     *ngrxLet="{datasSurMesurePhaseB: selectDatasSurMesurePhaseB$, datasTarificationPhaseB$: selectDatasTarificationPhaseB$} as data">
  @for (elt of ar; track elt.id; let j = $index) {
    @switch (elt.id) {
      @case ('HEADER') {
        <div class='left-header-cell price-header-cell' [ngStyle]="elt.style">
          {{ elt.header }}
          <br>
          {{ elt.header2 }}
        </div>
      }
      @default {
        <div class='left-header-cell' [ngStyle]="elt.style" style="position: relative">
          @if (elt.isElligible | CheckEligiblePipe) {
            @if (elt.id !== formuleProduct.FORMULE_GROUPAMA_GAV) {
              <input [id]="elt.id"
                     class="input" [ngStyle]="elt.id | ColorPipe"
                     (blur)="onBlur()"
                     mask="separator.2"
                     placeholder="-"
                     [showMaskTyped]="false"
                     type="text"
                     thousandSeparator=" "
                     [formControlName]="elt.id"
                     suffix="€"
                     [readOnly]="readOnly$ | ngrxPush"
                     [matTooltip]="(readOnly$ | ngrxPush) ? 'Veuillez sélectionner la case a cocher en bas de la colonne pour pouvoir modifier les valeurs' : ''"
                     decimalMarker=",">
            } @else {
              <select [formControlName]="elt.id"
                      (change)="onBlur()"
                      [disabled]="readOnly$ | ngrxPush"
                      class="input list" [ngStyle]="elt.id | ColorPipe : true">
                @for (seuil of seuils; track seuil.key) {
                  <option [ngStyle]="elt.id | ColorPipe : false" style="text-align: center;" [value]="seuil.key">
                    {{ seuil.value }} %
                  </option>
                }
              </select>
            }
          } @else {
            <span style="width: 100%">
                <img [src]="elt.img" class="img">
            </span>
          }
        </div>
      }
    }
  }
  <ng-container *ngrxLet="{prices:changePrice$ | async } as datas">
    @if (!!datas) {
      <div class="left-header-cell price-header-cell"
           style="background-color: #EEEEEE;font-weight: 800;font-size: 17px">
        {{ datas.prices | PricePrecoPipe : formule.SUR_MESURE }}&nbsp;<span style="font-size: 10px">/mois<sup>(3)</sup></span>
        &nbsp; &nbsp;<mat-checkbox (change)="checkSurMesure(data.datasSurMesurePhaseB, data.datasTarificationPhaseB$)"
                                   [formControlName]="formuleSelected"></mat-checkbox>
      </div>
    }
  </ng-container>
</div>
